@if (smsSent()) {
  <form nz-form nzLayout="vertical" [formGroup]="verifyForm">
    <beautyapp-input
      formControlName="code"
      placeholder="Sms Code"
      prefixIcon="message"
      label="Sms Code"
      [required]="true"
      [suffix]="suffix"
    />
    <ng-template #suffix>
      <button nz-button nzType="primary" (click)="resend()"
              type="button"
      >Resend
      </button>
    </ng-template>
  </form>
} @else {
  <form nz-form nzLayout="vertical" [formGroup]="form">
    <beautyapp-input
      formControlName="mobilePhone"
      placeholder="Mobile Phone"
      prefixIcon="mobile"
      label="Mobile Phone"
      [required]="true"
    />
    <beautyapp-input
      formControlName="firstname"
      placeholder="First Name"
      label="First Name"
      prefixIcon="user"
      [required]="true"
    />
    <beautyapp-input
      formControlName="lastname"
      placeholder="Last Name"
      label="Last Name"
      prefixIcon="user"
      [required]="true"
    />
    <beautyapp-input
      formControlName="identityNumber"
      placeholder="Identity Number"
      prefixIcon="idcard"
      label="Identity Number"
      [required]="true"
    />
    <beautyapp-datepicker
      formControlName="birthDate"
      placeholder="Birth Date"
      label="Birth Date"
      [required]="true"
    />
    <beautyapp-input
      formControlName="email"
      placeholder="Email"
      prefixIcon="mail"
      label="Email"
    />
  </form>
}

<div *nzModalFooter>
  <button nz-button nzType="default" (click)="modalRef.close()">Close</button>
  @if (smsSent()) {
    <button nz-button nzType="primary" (click)="verifySms()">Confirm</button>
  } @else {
    <button nz-button nzType="primary" (click)="startVerify()">Verify</button>
  }
</div>
